<template>
  <ul class="circle-list">
    <li
      v-for="(item, index) in items"
      :key="index"
      class="circle-list__item"
    >
      <!-- pallino allineato alla prima riga del titolo -->
      <span class="circle-list__circle"></span>

      <div class="circle-list__content">
        <p v-if="item.title" class="circle-list__title">{{ item.title }}</p>
        <p v-if="item.text" class="circle-list__text">{{ item.text }}</p>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'circle-list',

    props: {
      // elenco delle voci, ognuna { title, text }
      items: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>

<style lang="scss" scoped>

  .circle-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: $grid-gutter-width / 3;
    padding: 0;
    margin: 0;
    list-style: none;

    // due colonne da ~355px non stanno in un viewport mobile
    @include media-breakpoint-down(sm) {
      grid-template-columns: minmax(0, 1fr);
    }

    &__item {
      display: flex;
      align-items: flex-start;
      padding: $grid-gutter-width / 2;
      background-color: $gray-100;
      border: $border-width solid $gray-200;
      border-radius: $border-radius-lg * 2;
    }

    &__circle {
      flex-shrink: 0;
      width: 8px;
      height: 8px;
      margin-top: 8px;
      margin-right: $grid-gutter-width / 3;
      background-color: $primary;
      border-radius: 50%;
    }

    &__title {
      margin: 0;
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      color: $primary;
      line-height: normal;
    }

    &__text {
      margin: 2px 0 0;
      font-size: $font-size-md;
      color: $gray-900;
    }
  }
</style>